export class SecurityGroupModel {
    public organisationId: string;
    public securityGroupId: string;
    public securityGroupName: string;
    public sortSequence: string;
    public statusCode: string;
    public commitBy: string;
    public commitDateTime: string;
}